import React from 'react';
import { Box, FormLabel } from '@material-ui/core';
import errorPageStyles from './ErrorPage.style';
import PropTypes from 'prop-types';
import { DEFAULT_ERR_MSG } from 'constants/constant';

function ResponsiveText(props) {
	const { isSmallScreen, text = undefined } = props;
	const classes = errorPageStyles({ isSmallScreen });

	return (
		<Box display="flex" justifyContent="center" mt={1}>
			<FormLabel className={classes.formLabel}>{text || DEFAULT_ERR_MSG}</FormLabel>
		</Box>
	);
}

ResponsiveText.propTypes = {
	isSmallScreen: PropTypes.bool,
	text: PropTypes.string
};

export default ResponsiveText;
